export const hotel = {
  evaluation: "評価：{{num}}",
  perNightPerRoom: "{{price}} / 1泊1部屋",
  perNightPerPerson: "{{price}} / 1泊1名",
  room: "部屋：{{name}}",
};
